import Http from "./http";

export const exportAiCampaignResultsAPI = (payload) => {
  return Http.post("admin/campaign/download-report", payload);
};
